//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SearchSort",
	props: {
		results: Object,
		setSort: Function,
		sort: Object,
	},
	computed: {
		sortModel: {
			get() {
				return this.sort;
			},
			set(val) {
				this.setSort(val);
			},
		},
	},
	mounted() {
		const label = this.$el.querySelector("label.search-sort__label");
		const select = this.$el.querySelector("select.search-sort__select");
		const labelWidth = label.offsetWidth;
		const selectWidth = select.offsetWidth;
		if (window.screenWidth > 991) select.style.minWidth = `calc(${labelWidth}px + ${selectWidth}px)`;
	},
};
